import { RouteRecordRaw } from "vue-router";
import Layout from "@/layout/Index.vue";

const Admage: Array<RouteRecordRaw> = [
  {
    path: "/admage",
    component: Layout,
    redirect: "/ads",
    meta: {
      title: "admage",
      icon1: 'advertising1',
      icon2: 'advertising2',
      noCache: true
    },
    children: [
      {
        path: "asset",
        component: () => import(/* webpackChunkName: "asset" */"@/views/adManage/asset.vue"),
        name: "assetmage",
        meta: {
          title: "asset",
          noCache: true
        }
      },
      {
        path: "ads",
        component: () => import(/* webpackChunkName: "ads" */"@/views/adManage/ads.vue"),
        name: "adsmage",
        meta: {
          title: "ads",
          noCache: true
        }
      },
      {
        path: "adsdetail",
        component: () => import(/* webpackChunkName: "adsDetail" */"@/views/adManage/adsDetail.vue"),
        name: "adsdetail",
        meta: {
          title: "adsDetail",
          noCache: true,
          hidden: true
        }
      },
      {
        path: "addads",
        component: () => import(/* webpackChunkName: "addAds" */"@/views/adManage/addAds.vue"),
        name: "addads",
        meta: {
          title: "addAds",
          noCache: true,
          hidden: true
        }
      },
      {
        path: "editads",
        component: () => import(/* webpackChunkName: "editAds" */"@/views/adManage/editAds.vue"),
        name: "editads",
        meta: {
          title: "editAds",
          noCache: true,
          hidden: true
        }
      },
    ]
  }
];

export default Admage;
